import Filter1 from '@mui/icons-material/Filter1';
import Filter2 from '@mui/icons-material/Filter2';
import Filter3 from '@mui/icons-material/Filter3';
import Filter4 from '@mui/icons-material/Filter4';
import Filter5 from '@mui/icons-material/Filter5';
import Filter6 from '@mui/icons-material/Filter6';
import Filter7 from '@mui/icons-material/Filter7';
import Filter8 from '@mui/icons-material/Filter8';
import Filter9 from '@mui/icons-material/Filter9';
import Filter9plus from '@mui/icons-material/Filter9Plus';
import { red } from '@mui/material/colors';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Component } from 'react';

class IconeQuantidade extends Component {
    mapaIconesQuantidade = {
        1: <Filter1 style={this.style} />,
        2: <Filter2 style={this.style} />,
        3: <Filter3 style={this.style} />,
        4: <Filter4 style={this.style} />,
        5: <Filter5 style={this.style} />,
        6: <Filter6 style={this.style} />,
        7: <Filter7 style={this.style} />,
        8: <Filter8 style={this.style} />,
        9: <Filter9 style={this.style} />
    };

    constructor(props) {
        super(props);
    }

    get style() {
        return this.props.style || { color: red[900], fillOpacity: '0.6' };
    }

    render() {
        if (!this.props.quantidade) {
            return null;
        }

        if (this.props.quantidade > 9) {
            return <Filter9plus style={this.style} />;
        }

        return this.mapaIconesQuantidade[this.props.quantidade];
    }
}

IconeQuantidade.propTypes = {
    style: PropTypes.object,
    quantidade: PropTypes.number.isRequired
};

export default observer(IconeQuantidade);
